import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import color from '@deprecated-ui/_style/color';
import { formatBondCurrency } from 'features/securities/withdrawal/utils';
import { Divider } from 'antd';
import Icon from '@ant-design/icons';
import InfoSvg from 'global/Securities/components/Icons/InfoSvg';
import { BorderedContainer } from '../../../styled';
import { BondInfoType } from '../../../constants';
import { useBondInfoModal } from '../../../stores/useBondInfoModal';

interface Props {
  total?: number;
  accruedInterest?: number;
  sellerCoupon?: number;
}

export default function Summary({
  total = 0,
  accruedInterest = 0,
  sellerCoupon = 0,
}: Props) {
  const openInfoModal = useBondInfoModal((s) => s.openInfoModal);

  return (
    <BorderedContainer>
      <Flex direction="column" align="center" justify="center">
        <Text color="#858585" size="12px">
          Total Penerimaan Kupon{' '}
        </Text>
        <Text color={color.primary} size="20px" family="bold">
          {formatBondCurrency(total)}
        </Text>
      </Flex>
      <Divider
        css={`
          margin: 8px 0px;
        `}
      />
      <Flex justify="space-between" align="center">
        <Flex direction="column" align="center" justify="center" width="100%">
          <Text color="#858585" size="12px">
            Total Kupon Hak Kamu{' '}
            <Icon
              component={InfoSvg}
              style={{ color: '#969696' }}
              onClick={() => openInfoModal(BondInfoType.USER_COUPON)}
            />
          </Text>
          <Text size="14px" family="bold">
            {formatBondCurrency(accruedInterest)}
          </Text>
        </Flex>
        <Divider
          type="vertical"
          css={`
            height: 40px;
          `}
        />
        <Flex direction="column" align="center" justify="center" width="100%">
          <Text color="#858585" size="12px">
            Total Kupon Penjual{' '}
            <Icon
              component={InfoSvg}
              style={{ color: '#969696' }}
              onClick={() =>
                openInfoModal(BondInfoType.ACCRUED_INTEREST_SELLER)
              }
            />
          </Text>
          <Text size="14px" family="bold">
            {formatBondCurrency(sellerCoupon)}
          </Text>
        </Flex>
      </Flex>
    </BorderedContainer>
  );
}
